import {
    IMPORT_REJECTION_CELL_MAX_LENGTH,
    IMPORT_REJECTION_ROW_NUMBERS_CAP,
    ImportRejectionRowProblem,
} from "@common/schemas/domains/accounting/import-rejection.schema";

export interface ImportRejectionFlaggedRow {
    rowNumber: number;
    problem?: string;
}

export interface ImportRejectionFlaggedRows {
    rowNumbers?: number[];
    rowProblems?: ImportRejectionRowProblem[];
}

export function collectImportRejectionFlaggedRows(
    rows: ReadonlyArray<ImportRejectionFlaggedRow | null>,
): ImportRejectionFlaggedRows {
    const problemsByRow = new Map<number, string[]>();
    for (const row of rows) {
        if (row == null || row.rowNumber < 1) {
            continue;
        }
        const problems = problemsByRow.get(row.rowNumber) ?? [];
        const problem = row.problem?.trim();
        if (problem && !problems.includes(problem)) {
            problems.push(problem);
        }
        problemsByRow.set(row.rowNumber, problems);
    }
    const rowNumbers = [...problemsByRow.keys()]
        .sort((left, right) => left - right)
        .slice(0, IMPORT_REJECTION_ROW_NUMBERS_CAP);
    if (rowNumbers.length === 0) {
        return {};
    }
    const rowProblems = rowNumbers.flatMap((rowNumber) => {
        const problems = problemsByRow.get(rowNumber) ?? [];
        if (problems.length === 0) {
            return [];
        }
        return [
            {
                rowNumber,
                problem: problems
                    .join("; ")
                    .slice(0, IMPORT_REJECTION_CELL_MAX_LENGTH),
            },
        ];
    });
    return {
        rowNumbers,
        rowProblems: rowProblems.length > 0 ? rowProblems : undefined,
    };
}

export function collectImportRejectionRowNumbers(
    rows: ReadonlyArray<ImportRejectionFlaggedRow | null>,
): number[] | undefined {
    return collectImportRejectionFlaggedRows(rows).rowNumbers;
}
